import * as net from 'util/Net';

export interface ChatCanvasPreviewResponse {
  signedUrl: string;
  // ISO 8601 timestamp string (`datetime.isoformat()` on the backend).
  expiresAt: string;
  sdkVersion: string;
}

export function getChatCanvasPreviewUrl(
  chatSessionId: string,
  canvasVersionId: string,
  filePath: string = 'index.html'
): Promise<ChatCanvasPreviewResponse> {
  return net.postJSONPromise({
    url: `/1/api/llm/chats/${chatSessionId}:render-canvas`,
    data: {canvasVersionId, filePath},
  });
}
